import React, { useState, useEffect } from "react";
import { RESET_PASSWORD_HEADER, EMAILREGEX, MODAL_SIZE } from "../../App.config";
import validation from "../../utilities/validation";
import * as utilities from "../../utilities/utils";
import ChangePasswordModal from '../../containers/UserForm/changePasswordModal'




const ResetPasswordComponent = (props) => {
  const initialState = {
    email: {
      value: "",
      error: "",
      isValidationCheck: true,
      validation: {
        required: true,
        matchPattern: EMAILREGEX,
      },
    },
    otp: {
      value: "",
      error: "",
      isValidationCheck: false,
      validation: {
        required: true
        // matchPattern: EMAILREGEX,
      },
    },
    isOtpShow: {
      value: false
    },
    isEmailShow: {
      value: true
    },
    isSubmitOnce: { value: false },
  };
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (!props.modalReducer.IsOpen) {
      setState((state) => {
        return { ...initialState };
      });
      // props.resetVerifyOtpData();

    }
  }, [props.modalReducer.IsOpen])

  useEffect(() => {
    if (props.forgotPasswordReducer.otpData) {
      let authUserId = props.forgotPasswordReducer.otpData.userId
      props.openSetModalAction(<ChangePasswordModal
        authUserId={authUserId}
        callApiText={"ResetPasswordModal"}
        {...props}
      />,
        MODAL_SIZE.MODAL_SM
      );
    }
  }, [props.forgotPasswordReducer.otpData]);

  useEffect(() => {
    if (props.forgotPasswordReducer.IsOtpSend) {
      props.resetIsOtpSend(false);
      let updatedObj1 = state.isOtpShow
      let updatedObj2 = state.isEmailShow
      let updatedObj3 = state.otp
      // let updatedObj4 = state.email

      updatedObj1.value = true
      updatedObj2.value = false
      updatedObj3.isValidationCheck = true
      // updatedObj4.isValidationCheck = false
      setState((state) => {
        return {
          ...state,
          ["isOtpShow"]: updatedObj1,
          ["isEmailShow"]: updatedObj2,
          ["otp"]: updatedObj3,
          // ["email"]: updatedObj4
        };
      });
      // props.openSetModalAction(<OTPModalComponent />, MODAL_SIZE.MODAL_SM);
    }

  }, [props.forgotPasswordReducer.IsOtpSend]);

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return {
        ...state,
        [name]: updatedObj,
      };
    });
  };

  const FormValidation = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length && state[property].isValidationCheck
      ) {
        let validatedObj = validation(state[property]);

        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const isFormValid = () => {
    let isValid = true;
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length && state[property].isValidationCheck
      ) {
        if (state[property]?.error.length > 0) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  const onSubmit = () => {
    setState((state) => {
      return {
        ...state,
        isSubmitOnce: utilities.convertIntoObject(true),
      };
    });

    FormValidation();


    if (isFormValid()) {
      if (state.email.value && state.otp.value) {
        props.verifyOtp(state.email.value, state.otp.value);
      }
      else
        props.verifyEmailAddress(state.email.value);
    }
  };

  return (
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {RESET_PASSWORD_HEADER}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => props.closeRemoveModal()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <span>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="form-group">
                  {state.isEmailShow.value && <label htmlFor="">
                    {/* {props.context.t("Login-Reset-Password.label.text.Email")} */}
                    Email Address / Adresse courriel
                    <span size="5" className="error-star">
                      *
                    </span>
                  </label>}
                  {state.isEmailShow.value && <div className="form-group">
                    <input
                      placeholder="Type Here "
                      // {props.context.t(
                      //   "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      // )}
                      className="form-control"
                      name="email"
                      value={state.email.value}
                      onChange={handleChanges}
                    />
                    {state.email?.error && (
                      <span className="error">{state.email.error}</span>
                    )}
                  </div>}
                  <div className="form-group">
                    {state.isOtpShow.value && <label htmlFor="">
                      Enter OTP / Inscrire le mot de passe temporaire.
                      {/* {props.context.t("Login-Reset-Password.label.text.Email")} */}
                      <span size="5" className="error-star">
                        *
                      </span>
                    </label>}
                    {state.isOtpShow.value &&
                      <input
                        placeholder={props.context.t(
                          "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                        )}
                        className="form-control"
                        name="otp"
                        value={state.otp.value}
                        onChange={handleChanges}
                      />
                    }
                    {state.isOtpShow.value && state.otp?.error && (
                      <span className="error">{state.otp.error}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </span>
        </div>
        <div className="modal-footer">
          <button onClick={onSubmit} type="button" className="btn btn-primary">
            Submit / Soumettre
          </button>
        </div>
      </div>
    </div>
  );
};
export default ResetPasswordComponent;
